/* custom selectmenu widget extension: multiline + css theming support */

var multilineSelectmenu = $.widget("ui.multilineSelectmenu", $.ui.selectmenu, {
    _setText: function (element, value) {
        if (!value) {
            element.html("&#160;");
            return;
        }

        // Escape text so variant titles/prices can't break the markup
        function esc(str) {
            return $("<div>").text(str).html();
        }

        // No multiline marker — just set plain text and stop
        if (value.indexOf('|') === -1) {
            element.text(value);
            return;
        }

        var lines = value.split('|');
        var header = esc(lines[0].trim());

        // Wrap the first "(...)" group in the small-text span
        header = header.replace(/\(([^)]*)\)/, '<span class="smalltext wow">($1)</span>');

        var html = '<span class="ui-selectmenu-menu-item-header">' + header + '</span>';

        for (var i = 1; i < lines.length; i++) {
            html += '<span class="ui-selectmenu-menu-item-content">' + esc(lines[i].trim()) + '</span>';
        }

        element.html(html);

        // Clean, single label for screen readers (both button and options)
        var plain = lines.map(function (l) { return l.trim(); })
                         .filter(Boolean)
                         .join(', ');
        element.attr('aria-label', plain);
    }
});